const AUTH_ERROR_KEY_MAP = {
  "auth/invalid-email": ["auth.errors.invalidEmail", "Please enter a valid email address."],
  "auth/user-not-found": [
    "auth.errors.userNotFound",
    "Sorry, we could not find an account with those details. Please check and try again.",
  ],
  "auth/wrong-password": [
    "auth.errors.wrongPassword",
    "Your password looks incorrect. Please try again or reset it.",
  ],
  "auth/invalid-credential": [
    "auth.errors.loginFailed",
    "Sorry, we could not sign you in. Please check your details and try again.",
  ],
  "auth/email-already-in-use": [
    "auth.errors.emailAlreadyInUse",
    "This email is already in use. Please sign in or use another email.",
  ],
  "auth/weak-password": [
    "auth.errors.weakPassword",
    "Your password is too weak. Use a stronger password and try again.",
  ],
  "auth/too-many-requests": [
    "auth.errors.tooManyAttempts",
    "Too many attempts. Please wait a moment and try again.",
  ],
  "auth/user-disabled": [
    "auth.errors.userDisabled",
    "This account is currently unavailable. Please contact support.",
  ],
  "auth/popup-closed-by-user": [
    "auth.errors.popupClosed",
    "Sign-in was canceled. Please try again when you are ready.",
  ],
  "auth/cancelled-popup-request": [
    "auth.errors.popupClosed",
    "Sign-in was canceled. Please try again when you are ready.",
  ],
  "auth/popup-blocked": [
    "auth.errors.popupBlocked",
    "Your browser blocked the sign-in window. Please allow popups and try again.",
  ],
  "auth/unauthorized-domain": [
    "auth.errors.unauthorizedDomain",
    "Google sign-in is not available here right now. Please use email sign-in instead.",
  ],
  "auth/network-request-failed": [
    "auth.errors.authError",
    "We could not connect right now. Please check your internet and try again.",
  ],
  "auth/operation-not-allowed": [
    "auth.errors.operationNotAllowed",
    "This sign-in method is not available right now. Please use another method.",
  ],
  "auth/requires-recent-login": [
    "auth.errors.sessionExpired",
    "For your security, please sign in again and retry.",
  ],
  "auth/user-token-expired": [
    "auth.errors.sessionExpired",
    "Your session has expired. Please sign in again.",
  ],
  "auth/expired-action-code": [
    "auth.errors.expiredActionCode",
    "This link has expired. Please request a new one.",
  ],
  "auth/invalid-action-code": [
    "auth.errors.invalidActionCode",
    "This link is invalid or has already been used. Please request a new one.",
  ],
};

function extractAuthCode(error) {
  if (typeof error?.code === "string" && error.code.startsWith("auth/")) {
    return error.code;
  }

  const message = typeof error?.message === "string" ? error.message : "";
  const match = message.match(/auth\/[a-z0-9-]+/i);
  return match ? match[0].toLowerCase() : null;
}

export function getFriendlyAuthError(error, t, options = {}) {
  const {
    defaultKey = "auth.errors.authError",
    defaultMessage = "Something went wrong while signing you in. Please try again.",
  } = options;

  const code = extractAuthCode(error);
  if (code && AUTH_ERROR_KEY_MAP[code]) {
    const [key, fallback] = AUTH_ERROR_KEY_MAP[code];
    return t(key, fallback);
  }

  if (typeof error?.message === "string") {
    const normalized = error.message.trim().toLowerCase();
    if (normalized === "no user signed in") {
      return t("auth.signInRequiredContinue", "Please sign in to continue.");
    }
  }

  return t(defaultKey, defaultMessage);
}
